import { useLanguage, Language } from "@/i18n/LanguageContext";
import { cn } from "@/lib/utils";

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  const options: { value: Language; label: string }[] = [
    { value: "de", label: "DE" },
    { value: "fr", label: "FR" },
    { value: "en", label: "EN" },
  ];

  return (
    <div className="fixed top-4 right-4 z-50 flex rounded-full border border-primary-foreground/20 bg-primary/80 backdrop-blur-sm overflow-hidden shadow-lg">
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => setLanguage(opt.value)}
          className={cn(
            "px-4 py-2 text-sm font-semibold transition-colors",
            language === opt.value
              ? "bg-accent text-accent-foreground"
              : "text-primary-foreground/70 hover:text-primary-foreground"
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
